export enum SliceType {
    inline = 1,
    crossLine = 2,   
    depth = 3
}
